module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "P_TOC_Heading"
  }, [_c('a', {
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")])]), _c('a', {
    attrs: {
      "id": "tableofcontents"
    }
  }), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "id": "tableofcontents"
    }
  }), _c('a', {
    attrs: {
      "href": "#/section0001"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0002"
    }
  }, [_vm._v("Other Anthologies Edited by:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0003"
    }
  }, [_vm._v("Dragonesque")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004"
    }
  }, [_vm._v("Copyright © 2023 S.C. Butler, Joshua Palmatier, and")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005"
    }
  }, [_vm._v("Copyrights")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006"
    }
  }, [_vm._v("SLAY")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0007"
    }
  }, [_vm._v("AVARICE AND VENGEANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0008"
    }
  }, [_vm._v("THE PRINCESS NETWORK")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0009"
    }
  }, [_vm._v("COLD FIRE OF MANHATTAN")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0010"
    }
  }, [_vm._v("DUCK, DUCK, DRAGON")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0011"
    }
  }, [_vm._v("SHEEP RARELY WEAR GOLD")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0012"
    }
  }, [_vm._v("THE EXPOSÉ")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0013"
    }
  }, [_vm._v("LORD BAI AND THE MAGIC PIRATE")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0014"
    }
  }, [_vm._v("TATSU: CRYO FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0015"
    }
  }, [_vm._v("A KING ARTHUR DRAGON IN SPACE STATION 23’S COURT")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0016"
    }
  }, [_vm._v("MIGRATION SEASON")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0017"
    }
  }, [_vm._v("BONE AND BLOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0018"
    }
  }, [_vm._v("THE BREEDING HABITS OF DRAGONS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0019"
    }
  }, [_vm._v("GODS IN CHAINS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0020"
    }
  }, [_vm._v("THE LEFT HAND OF GIORDINO")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0021"
    }
  }, [_vm._v("REENACTMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0022"
    }
  }, [_vm._v("ABOUT THE AUTHORS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0023"
    }
  }, [_vm._v("ABOUT THE EDITORS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0024"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe16a79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableOfContents.vue
// module id = 57
// module chunks = 0